import { searchJobs, tagCandidatesToJob } from '../../../../services/popupApi';
import { createWorkflowInstance } from '../../../../services/workflowApi';

const STAGE_ID_BY_KEY = {
  pipeline: 'pipeline',
  goodfited: 'goodfited',
  contacted: 'contacted',
  submitted: 'submitted',
  shortlisted: 'shortlisted',
  interviewinprogress: 'interviewInprogress',
  selected: 'selected',
};

function pickValue(record, ...paths) {
  for (const path of paths) {
    const value = String(path).split('.').reduce((current, part) => current?.[part], record);
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return undefined;
}

function normalizeStageId(stage) {
  const raw = String(stage ?? '').trim();
  if (!raw) return '';
  return STAGE_ID_BY_KEY[raw.toLowerCase()] ?? raw;
}

function buildCandidateDetails(record, fallbackCandidateId) {
  const candidateId = pickValue(
    record,
    'candidateId',
    'candidate_id',
    'applicantId',
    'applicantID',
    'applicantReferenceId',
    'applicantRefrenceId',
    '_id',
    'id',
  ) ?? fallbackCandidateId;

  if (!candidateId) return null;

  const candidateName = (
    pickValue(record, 'candidateName', 'candidate_name', 'fullName', 'name')
    ?? [pickValue(record, 'firstName', 'first_name'), pickValue(record, 'lastName', 'last_name')]
      .filter(Boolean)
      .join(' ')
  ) || undefined;

  const candidateDetails = {
    candidateId: String(candidateId),
    candidateName,
    phone: pickValue(record, 'phone', 'phoneNumber', 'phone_number', 'mobile', 'mobileNumber', 'mobile_number'),
    source: pickValue(record, 'source', 'sourceType', 'candidateSource', 'profileSource'),
    submittedAt: pickValue(record, 'submittedAt', 'lastSubmittedAt', 'updatedAt'),
    remarks: pickValue(record, 'remarks', 'comment', 'comments', 'notes'),
    assignedRecruiter: pickValue(record, 'assignedRecruiter', 'recruiterName', 'ownerName', 'assignedToName'),
    screeningStatus: pickValue(record, 'screeningStatus', 'screening.status', 'screeningResult'),
    screeningScore: pickValue(record, 'screeningScore', 'screening.score', 'score'),
    assignedDate: pickValue(record, 'assignedDate', 'assignedAt', 'createdAt'),
  };

  return Object.fromEntries(Object.entries(candidateDetails).filter(([, value]) => value !== undefined && value !== null && value !== ''));
}

export const api = {
  searchOptions: async (field, search) => {
    if (field.searchFetchKey === 'tagToJobJobList') return searchJobs(search);
    return [];
  },
  submit: async (values, context) => {
    const selectedJobId = values.jobId ?? context.jobId;
    const selectedHiringStage = normalizeStageId(values.hiringStage ?? context.hiringStage);
    const selectedIds = Array.isArray(context.selectedIds) ? context.selectedIds : [];
    const selectedRecords = Array.isArray(context.selectedRecords) ? context.selectedRecords : [];
    const totalCandidates = Math.max(selectedIds.length, selectedRecords.length, 1);

    for (let index = 0; index < totalCandidates; index += 1) {
      const fallbackCandidateId = selectedIds[index] ? String(selectedIds[index]) : '';
      const candidateDetails = buildCandidateDetails(selectedRecords[index] ?? {}, fallbackCandidateId);
      await createWorkflowInstance({
        jobId: selectedJobId,
        module: 'jobs',
        currentStage: selectedHiringStage,
        ...(candidateDetails ? { candidateDetails } : {}),
      });
    }

    await tagCandidatesToJob({
      jobId: selectedJobId,
      candidateIds: context.selectedIds,
      hiringStage: selectedHiringStage,
    });
  },
};
